"use client"

import styled from "@emotion/styled"
import Image from "next/image"
import "swiper/css"
import { Swiper, SwiperSlide } from "swiper/react"
import { NewText } from "ui"

// Experts section
const ExpertsSection = styled.div`
  background-color: #2aa749;
  height: 89px;
  ${(props) => props.theme.breakpoints.up("sm")} {
    height: 83px;
  }

  ${(props) => props.theme.breakpoints.up("xl")} {
    height: 125px;
  }

  box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  padding: 0px 10px;
`

const ExpertCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 65px;
  gap: 5px;
  height: 100%;
  padding-top: 12px;
  padding-bottom: 14px;
  ${(props) => props.theme.breakpoints.up("sm")} {
    padding-top: 10px;
    padding-bottom: 12px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    padding-top: 16px;
    padding-bottom: 18px;
  }
`

const ExpertImageWrapper = styled.div`
  width: 49px;
  height: 49px;
  ${(props) => props.theme.breakpoints.up("sm")} {
    width: 40px;
    height: 40px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    width: 65px;
    height: 65px;
  }
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  background: none;
  flex-shrink: 0;
`

const ExpertInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex: 1;
`

const ExpertName = styled(NewText)`
  text-align: center;
  width: 56px;
`

// const ExpertButton = styled(NewText)`
//   min-width: 40px;
//   min-height: 7px;
//   margin-top: auto;
//   ${(props) => props.theme.breakpoints.up("sm")} {
//     min-width: 36px;
//     min-height: 6px;
//   }
//   ${(props) => props.theme.breakpoints.up("xl")} {
//     min-width: 55px;
//     min-height: 9px;
//   }
//   background-color: white;
//   color: #009919;
//   border: none;
//   border-radius: 60px;
//   cursor: pointer;
//   transition: background-color 0.3s;

//   &:hover {
//     background-color: #f0f0f0;
//   }
// `

const experts = [
  { id: 1, name: "מיכאל פריידזון", image: "/images/expert-1.png" },
  { id: 2, name: "לירן קלה", image: "/images/expert-2.png" },
  { id: 3, name: "רוני קנופלר", image: "/images/expert-3.png" },
  { id: 4, name: "גרגורי בנימינוב", image: "/images/expert-4.png" },
  { id: 5, name: "נאור כפיר", image: "/images/expert-5.png" },
  { id: 6, name: "מיכאל חן", image: "/images/expert-6.png" },
  { id: 7, name: "איימן עיראקיי", image: "/images/expert-7.png" },
  { id: 8, name: "שלומי אוחנה", image: "/images/expert-8.png" },
  { id: 9, name: "אחמד טמיש", image: "/images/expert-9.png" },
  { id: 10, name: "אנדריי רזניק", image: "/images/expert-10.png" },
  { id: 11, name: "דור אליעזר", image: "/images/expert-11.png" },
  { id: 12, name: "חיים אייזנבך", image: "/images/expert-12.png" },
  { id: 13, name: "שחר רוטרמן", image: "/images/expert-13.png" },
  { id: 14, name: "מיכאל חן", image: "/images/expert-14.png" },
  { id: 15, name: "רפאל אסייג", image: "/images/expert-15.png" },
  { id: 16, name: "מנחם ברנשטיין", image: "/images/expert-16.png" },
  { id: 17, name: "אייל שרביט", image: "/images/expert-17.png" },
  { id: 18, name: "מיכאל חזן", image: "/images/expert-18.png" },
]

export default function ExpertsSwiper() {
  return (
    <ExpertsSection>
      <Swiper
        slidesPerView="auto"
        spaceBetween={10}
        freeMode={true}
        style={{
          width: "100%",
          height: "100%",
          padding: "0",
        }}
      >
        {experts.reverse().map((expert) => (
          <SwiperSlide
            key={expert.id}
            style={{
              width: "auto",
              height: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <ExpertCard>
              <ExpertImageWrapper>
                <Image
                  src={expert.image}
                  alt={expert.name}
                  fill
                  style={{ objectFit: "cover" }}
                  sizes="(max-width: 1200px) 40px, 65px"
                  priority={true}
                />
              </ExpertImageWrapper>
              <ExpertInfo>
                <ExpertName
                  component="span"
                  mobileFontSize={7.5}
                  smallDesktopFontSize={6}
                  desktopFontSize={10}
                  desktopLineHeight={"106.6%"}
                  desktopFontWeight={700}
                  color="white"
                >
                  {expert.name}
                </ExpertName>
                {/* <ExpertButton
                  component="button"
                  mobileFontSize={7}
                  smallDesktopFontSize={8}
                  desktopFontSize={8}
                  desktopLineHeight={"106.6%"}
                  desktopFontWeight={700}
                >
                  לפרטים &gt;
                </ExpertButton> */}
              </ExpertInfo>
            </ExpertCard>
          </SwiperSlide>
        ))}
      </Swiper>
    </ExpertsSection>
  )
}
